export default __webpack_public_path__ + "static/media/brainferg1.e3f35fd0.jpg";